import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Icon from 'components/common/Icon/Icon'
import Media from 'components/common/Media'
import {
  CALL_STORE_DESCRIPTION,
  SELECT_DATE_DESCRIPTION,
  SELECT_DATE_TITLE,
  CALL_STORE_TITLE
} from '../../constants'

const PromoExpirationNotification = ({
  handleCloseNotification,
  promotionDetailsList,
  isCallStorePromoExpiration = false,
  storePhoneNumber,
  formattedStorePhoneNumber
}) =>
  <Wrapper>
    <Header>
      <AlertIcon asset="alert-triangle-black" alt="Black alert triangle" />
      <CloseButton onClick={ handleCloseNotification }>
        <CloseButtonIcon asset="cross" alt="Cross icon" />
      </CloseButton>
      {isCallStorePromoExpiration
        ? <Title>{CALL_STORE_TITLE}</Title>
        : <Title>{SELECT_DATE_TITLE}</Title>
      }
      {isCallStorePromoExpiration
        ? <Description>{CALL_STORE_DESCRIPTION}</Description>
        : <Description>{SELECT_DATE_DESCRIPTION}</Description>
      }
    </Header>

    {Boolean(promotionDetailsList.length) && promotionDetailsList.map(({
      promotionId,
      promotionEndDate,
      promotionStartDate,
      promotionName
    }) => (
      <PromoDetails key={ promotionId }>
        <PromoName>{ promotionName }</PromoName>
        <PromoDates>{`Valid ${promotionStartDate} - ${promotionEndDate}`}</PromoDates>
      </PromoDetails>
    ))}

    {isCallStorePromoExpiration && (
      <CallStoreLink href={ `tel:${storePhoneNumber.length === 10 ? '+1' : ''}${storePhoneNumber}` }>
        <PhoneIcon asset="phone" alt="Phone icon" />
        {'Call the store at '}
        <PhoneNumber>{formattedStorePhoneNumber}</PhoneNumber>
      </CallStoreLink>
    )}

  </Wrapper>

export default PromoExpirationNotification

PromoExpirationNotification.propTypes = {
  formattedStorePhoneNumber: PropTypes.string,
  handleCloseNotification: PropTypes.func,
  isCallStorePromoExpiration: PropTypes.bool,
  promotionDetailsList: PropTypes.arrayOf(PropTypes.shape()),
  storePhoneNumber: PropTypes.string
}

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  padding: 34px 108px 20px 86px;
  background: ${Theme.colors.light_blue};
  border-radius: 6px;

  &::before {
    position: absolute;
    top: -15px;
    left: 30%;
    content: "";
    border-style: solid;
    border-width: 20px 35px 20px 0;
    border-color: transparent ${Theme.colors.light_blue} transparent transparent;
    transform: rotate(90deg);
    transform: scale(3, 1) rotate(90deg);
  }

  ${Media.mobile`
    padding: 36px 20px;
    border-radius: 0;
    &::before {
      left: 47%;
    }
  `}
`

const AlertIcon = styled(Icon)`
  position: absolute;
  left: 27px;
  top: 34px;
  ${Media.mobile`
    position: static;
    margin: 0 0 16px 0;
  `}
`

const CloseButton = styled.button`
  position: absolute;
  right: 19px;
  top: 23px;
  padding: 0;
  cursor: pointer;
  border: none;
  background: none;
`

const CloseButtonIcon = styled(Icon)`
  width: 23px;
`

const Header = styled.div`
  width: 100%;
  padding: 0 0 23px 0;
  margin: 0 0 16px 0;
  border-bottom: 1px solid ${Theme.colors.grey};
`

const Title = styled.p`
  margin: 0 0 3px 0;
  font-size: 18px;
  font-weight: 700;
  text-transform: uppercase;
  ${Media.mobile`
    margin: 0 0 9px 0;
  `}
`

const Description = styled.p`
  margin: 0;
  font-size: 16px;
`

const PromoDetails = styled.div`
  width: 100%;
  margin: 0 0 16px 0;
`

const PromoName = styled.p`
  margin: 0;
  font-size: 18px;
`

const PromoDates = styled.p`
  margin: 0;
  font-size: 16px;
`

const CallStoreLink = styled.a`
  display: flex;
  width: fit-content;
  padding: 10px 30px;
  font-size: 18px;
  border: 1px solid ${Theme.colors.blue};
  border-radius: 4px;
  background-color: ${Theme.colors.white};
  text-decoration: none;
  ${Media.mobile`
    font-size: 13px;
  `}
`

const PhoneIcon = styled(Icon)`
  margin: 0 16px 0 0;
  ${Media.mobile`
    margin: 0 12px 0 0;
  `}
`

const PhoneNumber = styled.p`
  margin: 0 0 0 5px;
  font-size: 18px;
  font-weight: 700;
  ${Media.mobile`
    font-size: 15px;
  `}
`
